import { ExitConfirm } from "app/components/modals/components/ExitConfirm";
import type { IProModal } from "pro-features/components/Modals/src/ProModal";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import type { ComponentProps, FC } from "react";

interface IExitConfirmModal {
    modalProps: IProModal;
    exitConfirmProps: ComponentProps<typeof ExitConfirm>;
}

export const ExitConfirmModal: FC<IExitConfirmModal> = (props) => {
    const { modalProps, exitConfirmProps } = props;
    return (
        <ProModal {...modalProps}>
            <ExitConfirm {...exitConfirmProps} />
        </ProModal>
    );
};
